/* eslint-disable */

// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
import '../polyfills'

import '../../components/index'

import '../src/javascripts/pagy.js.erb'
import debounced from 'debounced'

import { Application } from 'stimulus'
import { definitionsFromContext } from 'stimulus/webpack-helpers'
import analytics from '../packs/segment.js.erb'
import * as FullStory from '@fullstory/browser'
import { getAJAXRequests } from '../classes/get_ajax_requests'

// Import Flatpickr
import Flatpickr from 'stimulus-flatpickr'
import moment from 'moment'

import I18n from '../i18n/index.js.erb'
import * as LDClient from 'launchdarkly-js-client-sdk'
import { OfflineFeatureFlagEvaluator } from './OfflineFeatureFlagEvaluator'
const importAll = (r) => r.keys().map(r)
importAll(require.context('../../components', true, /[_\/]component\.js$/))
importAll(require.context('../src/images', true))
importAll(require.context('../src/fonts', true))

import LocalTime from "local-time"
LocalTime.start()

import jstz from 'jstz'
import { setCookie, getCookie } from '@app/javascript/classes/cookies'

const timezone = jstz.determine()
setCookie("timezone", timezone.name())

require('@rails/ujs').start()

require('turbolinks').start()

require('@rails/activestorage').start()
require('channels')
require('jquery')
require('jquery_deparam')

import hljs from 'highlight.js'
import 'highlight.js/styles/a11y-dark.css'
document.addEventListener('turbolinks:load', function() { hljs.highlightAll(); })

debounced.initialize()

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

require('trix')
require('@rails/actiontext')

const application = Application.start()

const viewContribContext = require.context('../../components', true, /index.js$/)
viewContribContext.keys().forEach((path) => {
  const mod = viewContribContext(path)

  // Check whether a module has the Controller export defined
  if (!mod.Controller) return

  // Convert path into a controller identifier:
  //   example/index.js -> example
  //   nav/user_info/index.js -> nav--user-info
  const identifier = path.replace(/^\.\//, '') // './' => ''
    .replace(/\/index\.js$/, '') // 'index.js' => ''
    .replace(/\//g, '--') // '\' => '--'
    .replace(/_/g, '-') // '_' => '-'

  application.register(identifier, mod.Controller)
})

const context = require.context('../controllers', true, /\.js$/)
const contextComponents = require.context('../../components', true, /.js$/)

application.load(
  definitionsFromContext(context).concat(
    definitionsFromContext(contextComponents)
  )
)

// Manually register Flatpickr as a stimulus controller
application.register('flatpickr', Flatpickr)
application.register('moment', moment)

// Import and register  TailwindCSS Components
import { Dropdown } from "tailwindcss-stimulus-components"
application.register('dropdown', Dropdown)
// If any controller has a "teardown" function defined on it,
// fire it in response to the turbolinks:before-cache event.
// @link https://github.com/hotwired/stimulus/issues/104#issuecomment-365393601
document.addEventListener('turbolinks:before-cache', function () {
  application.controllers.forEach(function (controller) {
    if (typeof controller.teardown === 'function') {
      controller.teardown()
    }
  })
})

FullStory.init({
  orgId: '1TXXH',
  recordCrossDomainIFrames: true,
  devMode: process.env.ENABLE_FULLSTORY === 'false'
})

if (typeof (gon) !== 'undefined') {
  if (gon.environment !== 'development' && gon.environment !== 'test') {
    document.domain = 'fiscalnote.com'
  }

  if (gon.environment === 'test') {
    window.ldclient = new OfflineFeatureFlagEvaluator(gon.flags)
  } else {
    window.ldclient = LDClient.initialize(gon.ld_client_id, {
      kind: 'user',
      key: gon.user_email,
      email: gon.user_email
    },
      {
        bootstrap: gon.flags
      }
    )
  }
}

// Open trix content into a new tab if it is a external link
$(document).ready(() => {
  $('.trix-content a').each((e, el) => {
    if (el.host !== window.location.host) {
      $(el).attr('target', '_blank')
    }
  })
})

window.getAJAXRequests = getAJAXRequests
